import QRCode from "qrcode";
import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { Product } from "../../types/product";
import { useTranslation } from "../../core/translation.core";

export default function QRCodeDisplay({ product }: { product: Product }) {
  const [printQty, setPrintQty] = useState(1);
  const { t, msg } = useTranslation();

  const componentRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <section>
      <QrComp product={product} />
      <div className="flex gap-2">
        <input
          value={printQty}
          type="number"
          min={0}
          max={1000}
          onChange={(e) => setPrintQty(Number(e.target.value || 0))}
          className="border rounded-lg w-16 text-center"
        />
        <button onClick={handlePrint} type="button" className="bg-her-blue text-white px-8 py-2 rounded-lg">
          {t(msg.pos.print)}
        </button>
        <CopyBtn product={product} />
      </div>
      {/* Printing Purposes Only. Is Not Rendered */}
      <div style={{ display: "none" }}>
        <div ref={componentRef} className="pt-20 px-10 flex flex-wrap">
          {Array.from(Array(printQty || 1).keys()).map((k, index) => (
            <QrComp product={product} key={product.id} />
          ))}
        </div>
      </div>
    </section>
  );
}

function QrComp({ product }: { product: Product }) {
  const ref = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    QRCode.toCanvas(ref.current, JSON.stringify({ id: product.id }), { toSJISFunc: (QRCode as any).toSJIS });
  }, [product]);

  return (
    <>
      <canvas className="border mb-2" ref={ref}></canvas>
    </>
  );
}

function CopyBtn({ product }: { product: Product }) {
  const { t, msg } = useTranslation();
  const [showCopied, setShowCopied] = useState(false);

  function copy() {
    navigator.clipboard.writeText(JSON.stringify({ id: product.id }));
    setShowCopied(true);

    setTimeout(() => {
      setShowCopied(false);
    }, 2000);
  }

  return (
    <>
      <button type="button" onClick={copy} className="ml-2 bg-her-blue text-white px-8 py-2 rounded-lg">
        {t(msg.pos.copy)}
      </button>
      {showCopied && <div className="pt-4 text-green-500">{t(msg.pos.copied)}</div>}
    </>
  );
}
